export const DameDataProducts = [{
    "id": 1,
    "image": "https://robohash.org/undeetsoluta.png?size=200x200&set=set1",
    "name": "Hedvige Woolforde",
    "description": "Blister (nonthermal) of right little finger, initial encounter",
    "price": 52
  }, {
    "id": 2,
    "image": "https://robohash.org/sitvoluptasratione.png?size=200x200&set=set1",
    "name": "Kesley Ashurst",
    "description": "Unspecified fracture of occiput, initial encounter for closed fracture",
    "price": 48
  }, {
    "id": 3,
    "image": "https://robohash.org/liberooditsit.png?size=200x200&set=set1",
    "name": "Lauryn Leynagh",
    "description": "Nondisplaced unspecified condyle fracture of lower end of right femur, subsequent encounter for closed fracture with routine healing",
    "price": 65
  }, {
    "id": 4,
    "image": "https://robohash.org/necessitatibuslaborumaccusamus.png?size=200x200&set=set1",
    "name": "Phyllys Nilles",
    "description": "Maternal care for (suspected) chromosomal abnormality in fetus, not applicable or unspecified",
    "price": 40
  }, {
    "id": 5,
    "image": "https://robohash.org/omniseumcorporis.png?size=200x200&set=set1",
    "name": "Jon Nacci",
    "description": "Nondisplaced fracture of body of hamate [unciform] bone, right wrist, initial encounter for closed fracture",
    "price": 11
  }, {
    "id": 6,
    "image": "https://robohash.org/consequaturiureconsequatur.png?size=200x200&set=set1",
    "name": "Keri Gilyott",
    "description": "Rheumatic aortic stenosis",
    "price": 91
  }, {
    "id": 7,
    "image": "https://robohash.org/blanditiisdoloresdeleniti.png?size=200x200&set=set1",
    "name": "Eliot Swire",
    "description": "Military operations involving fragments from weapons, civilian",
    "price": 90
  }, {
    "id": 8,
    "image": "https://robohash.org/eosnostrumquasi.png?size=200x200&set=set1",
    "name": "Tildy Caldero",
    "description": "Displaced spiral fracture of shaft of unspecified fibula, subsequent encounter for open fracture type IIIA, IIIB, or IIIC with nonunion",
    "price": 50
  }, {
    "id": 9,
    "image": "https://robohash.org/illummolestiaeipsum.png?size=200x200&set=set1",
    "name": "Tawnya Barg",
    "description": "Injury of unspecified nerve at forearm level, left arm, sequela",
    "price": 30
  }, {
    "id": 10,
    "image": "https://robohash.org/quamvoluptatemcum.png?size=200x200&set=set1",
    "name": "Ike Wankel",
    "description": "Displaced fracture of pisiform, unspecified wrist, subsequent encounter for fracture with delayed healing",
    "price": 49
  }, {
    "id": 11,
    "image": "https://robohash.org/quiseumin.png?size=200x200&set=set1",
    "name": "Erl Bukac",
    "description": "Other articular cartilage disorders, left hip",
    "price": 60
  }, {
    "id": 12,
    "image": "https://robohash.org/estquaesit.png?size=200x200&set=set1",
    "name": "Masha Leemans",
    "description": "Passenger in three-wheeled motor vehicle injured in collision with railway train or railway vehicle in traffic accident, sequela",
    "price": 70
  }, {
    "id": 13,
    "image": "https://robohash.org/debitissedreprehenderit.png?size=200x200&set=set1",
    "name": "Cale Dendle",
    "description": "Displaced fracture of medial condyle of right femur, subsequent encounter for open fracture type IIIA, IIIB, or IIIC with delayed healing",
    "price": 49
  }, {
    "id": 14,
    "image": "https://robohash.org/officiaipsamporro.png?size=200x200&set=set1",
    "name": "Carolyn Itchingham",
    "description": "Underdosing of unspecified drugs acting on muscles, sequela",
    "price": 27
  }, {
    "id": 15,
    "image": "https://robohash.org/quisautqui.png?size=200x200&set=set1",
    "name": "Kristin L'Hommee",
    "description": "Cataract extraction status, right eye",
    "price": 89
  }, {
    "id": 16,
    "image": "https://robohash.org/voluptatemfacilisfuga.png?size=200x200&set=set1",
    "name": "Desi Rowena",
    "description": "Acute perichondritis of external ear, unspecified ear",
    "price": 97
  }, {
    "id": 17,
    "image": "https://robohash.org/eteaaspernatur.png?size=200x200&set=set1",
    "name": "Adrian Lyddon",
    "description": "Laceration with foreign body of unspecified eyelid and periocular area",
    "price": 37
  }, {
    "id": 18,
    "image": "https://robohash.org/ipsamducimusminus.png?size=200x200&set=set1",
    "name": "Dolores Riggert",
    "description": "Other injury of other part of small intestine, sequela",
    "price": 23
  }, {
    "id": 19,
    "image": "https://robohash.org/quibusdamfugaet.png?size=200x200&set=set1",
    "name": "Kesley Rooze",
    "description": "Other contact with sea lion, sequela",
    "price": 88
  }, {
    "id": 20,
    "image": "https://robohash.org/eaducimusvel.png?size=200x200&set=set1",
    "name": "Karlens Ifill",
    "description": "Unspecified injury of long flexor muscle, fascia and tendon of unspecified thumb at wrist and hand level, initial encounter",
    "price": 76
  }, {
    "id": 21,
    "image": "https://robohash.org/molestiasconsecteturquaerat.png?size=200x200&set=set1",
    "name": "Darby Pharoah",
    "description": "Hereditary fructose intolerance",
    "price": 73
  }, {
    "id": 22,
    "image": "https://robohash.org/nemoestfacilis.png?size=200x200&set=set1",
    "name": "Quincy Heddy",
    "description": "Unspecified subluxation of right sternoclavicular joint, initial encounter",
    "price": 43
  }, {
    "id": 23,
    "image": "https://robohash.org/illumrerumpossimus.png?size=200x200&set=set1",
    "name": "Dunstan Nacey",
    "description": "Atherosclerosis of nonautologous biological bypass graft(s) of the left leg with ulceration of unspecified site",
    "price": 61
  }, {
    "id": 24,
    "image": "https://robohash.org/doloresetquis.png?size=200x200&set=set1",
    "name": "Raychel Spackman",
    "description": "Unspecified open wound of nose, sequela",
    "price": 50
  }, {
    "id": 25,
    "image": "https://robohash.org/impeditlaborumplaceat.png?size=200x200&set=set1",
    "name": "Nesta Fink",
    "description": "Legal intervention involving baton, suspect injured, subsequent encounter",
    "price": 87
  }, {
    "id": 26,
    "image": "https://robohash.org/autemitaqueesse.png?size=200x200&set=set1",
    "name": "Lurette Kilfeather",
    "description": "Anterior scleritis, unspecified eye",
    "price": 71
  }, {
    "id": 27,
    "image": "https://robohash.org/sedsuntenim.png?size=200x200&set=set1",
    "name": "Jameson Cromar",
    "description": "Diverticulum of bladder",
    "price": 92
  }, {
    "id": 28,
    "image": "https://robohash.org/quireiciendisreprehenderit.png?size=200x200&set=set1",
    "name": "Dniren Hickenbottom",
    "description": "Blister (nonthermal) of unspecified upper arm",
    "price": 13
  }, {
    "id": 29,
    "image": "https://robohash.org/asperioressuntvel.png?size=200x200&set=set1",
    "name": "Gabbie Poppleton",
    "description": "Mild to moderate pre-eclampsia, complicating the puerperium",
    "price": 47
  }, {
    "id": 30,
    "image": "https://robohash.org/aliquampossimuset.png?size=200x200&set=set1",
    "name": "Panchito Sanpere",
    "description": "Other tear of lateral meniscus, current injury, unspecified knee",
    "price": 44
  }, {
    "id": 31,
    "image": "https://robohash.org/quidemmolestiasratione.png?size=200x200&set=set1",
    "name": "Berti McEllen",
    "description": "Frostbite with tissue necrosis of unspecified sites, initial encounter",
    "price": 71
  }, {
    "id": 32,
    "image": "https://robohash.org/eaaliasvitae.png?size=200x200&set=set1",
    "name": "Kassie Allport",
    "description": "Displaced fracture of distal phalanx of right middle finger, subsequent encounter for fracture with nonunion",
    "price": 55
  }, {
    "id": 33,
    "image": "https://robohash.org/eosnamaut.png?size=200x200&set=set1",
    "name": "Roth Dundridge",
    "description": "Hemorrhagic otitis externa, right ear",
    "price": 46
  }, {
    "id": 34,
    "image": "https://robohash.org/delenitiutdolor.png?size=200x200&set=set1",
    "name": "Clarita Haddleston",
    "description": "Other mechanical complication of internal left knee prosthesis",
    "price": 5
  }, {
    "id": 35,
    "image": "https://robohash.org/aperiamconsecteturmollitia.png?size=200x200&set=set1",
    "name": "Don Redhouse",
    "description": "Dislocation of other parts of left shoulder girdle, initial encounter",
    "price": 72
  }, {
    "id": 36,
    "image": "https://robohash.org/enimveliusto.png?size=200x200&set=set1",
    "name": "Dehlia Fyrth",
    "description": "Passenger in heavy transport vehicle injured in collision with railway train or railway vehicle in traffic accident, sequela",
    "price": 60
  }, {
    "id": 37,
    "image": "https://robohash.org/molestiaeoditad.png?size=200x200&set=set1",
    "name": "Agata Pawnsford",
    "description": "Garage of children's home and orphanage as the place of occurrence of the external cause",
    "price": 64
  }, {
    "id": 38,
    "image": "https://robohash.org/magnirerumamet.png?size=200x200&set=set1",
    "name": "Cherianne Milbourn",
    "description": "Other intraoperative cardiac functional disturbances during other surgery",
    "price": 72
  }, {
    "id": 39,
    "image": "https://robohash.org/rationenecessitatibussimilique.png?size=200x200&set=set1",
    "name": "Tabbatha Nanni",
    "description": "Visceral larva migrans",
    "price": 69
  }, {
    "id": 40,
    "image": "https://robohash.org/earerumipsam.png?size=200x200&set=set1",
    "name": "Hercule Tissington",
    "description": "Sleep related bruxism",
    "price": 45
  }, {
    "id": 41,
    "image": "https://robohash.org/fugasaepequi.png?size=200x200&set=set1",
    "name": "Allyn Muselli",
    "description": "Diffuse traumatic brain injury with loss of consciousness of 1 hour to 5 hours 59 minutes, subsequent encounter",
    "price": 1
  }, {
    "id": 42,
    "image": "https://robohash.org/ettenetursint.png?size=200x200&set=set1",
    "name": "Janene Kinsett",
    "description": "Puncture wound without foreign body of left buttock, initial encounter",
    "price": 25
  }, {
    "id": 43,
    "image": "https://robohash.org/assumendaevenietex.png?size=200x200&set=set1",
    "name": "Kayle Simkovich",
    "description": "Impingement syndrome of right shoulder",
    "price": 57
  }, {
    "id": 44,
    "image": "https://robohash.org/enimnequevoluptatibus.png?size=200x200&set=set1",
    "name": "Truman Downe",
    "description": "Preterm labor second trimester with preterm delivery third trimester, fetus 4",
    "price": 33
  }, {
    "id": 45,
    "image": "https://robohash.org/impeditesseautem.png?size=200x200&set=set1",
    "name": "Glenn Woolfitt",
    "description": "Car driver injured in collision with pick-up truck in nontraffic accident, initial encounter",
    "price": 22
  }, {
    "id": 46,
    "image": "https://robohash.org/commodirepellendusut.png?size=200x200&set=set1",
    "name": "Odell Maharry",
    "description": "Malignant neoplasm of upper-outer quadrant of breast, female",
    "price": 6
  }, {
    "id": 47,
    "image": "https://robohash.org/voluptatemrationequia.png?size=200x200&set=set1",
    "name": "Rozanne Sharpley",
    "description": "Trigger finger, left little finger",
    "price": 27
  }, {
    "id": 48,
    "image": "https://robohash.org/molestiasquamomnis.png?size=200x200&set=set1",
    "name": "Gabriellia Canizares",
    "description": "Traumatic subarachnoid hemorrhage with loss of consciousness greater than 24 hours without return to pre-existing conscious level with patient surviving, sequela",
    "price": 70
  }, {
    "id": 49,
    "image": "https://robohash.org/necessitatibusearumamet.png?size=200x200&set=set1",
    "name": "Robyn Forlonge",
    "description": "Displaced fracture of base of second metacarpal bone, right hand, initial encounter for closed fracture",
    "price": 42
  }, {
    "id": 50,
    "image": "https://robohash.org/itaquemolestiaemaiores.png?size=200x200&set=set1",
    "name": "Tracie Jerzyk",
    "description": "Other acute osteomyelitis, left humerus",
    "price": 52
  }];

  export const DameDataResturants = [{
    "id": 1,
    "image": "https://robohash.org/fugaerrorrepellat.png?size=200x200&set=set1",
    "name": "Kilback, Bogisich and Heaney",
    "description": "Diffuse traumatic brain injury with loss of consciousness of any duration with death due to brain injury prior to regaining consciousness, subsequent encounter",
    "monthlyPrice": 139,
    "location": "http://dummyimage.com/105x100.png/cc0000/ffffff"
  }, {
    "id": 2,
    "image": "https://robohash.org/voluptatemetaut.png?size=200x200&set=set1",
    "name": "Conn LLC",
    "description": "Abnormal cytological finding on antenatal screening of mother",
    "monthlyPrice": 152,
    "location": "http://dummyimage.com/210x100.png/cc0000/ffffff"
  }, {
    "id": 3,
    "image": "https://robohash.org/doloreeosdicta.png?size=200x200&set=set1",
    "name": "Harber and Sons",
    "description": "Injury of other muscles, fascia and tendons at shoulder and upper arm level",
    "monthlyPrice": 123,
    "location": "http://dummyimage.com/160x100.png/dddddd/000000"
  }, {
    "id": 4,
    "image": "https://robohash.org/eaillumut.png?size=200x200&set=set1",
    "name": "Hyatt LLC",
    "description": "Displaced segmental fracture of shaft of unspecified fibula, initial encounter for closed fracture",
    "monthlyPrice": 48,
    "location": "http://dummyimage.com/185x100.png/cc0000/ffffff"
  }, {
    "id": 5,
    "image": "https://robohash.org/blanditiisbeataeassumenda.png?size=200x200&set=set1",
    "name": "Balistreri LLC",
    "description": "Nondisplaced transverse fracture of unspecified patella, subsequent encounter for open fracture type I or II with delayed healing",
    "monthlyPrice": 156,
    "location": "http://dummyimage.com/132x100.png/cc0000/ffffff"
  }, {
    "id": 6,
    "image": "https://robohash.org/debitissintqui.png?size=200x200&set=set1",
    "name": "Abshire Group",
    "description": "Abscess of tendon sheath, right hand",
    "monthlyPrice": 159,
    "location": "http://dummyimage.com/192x100.png/cc0000/ffffff"
  }, {
    "id": 7,
    "image": "https://robohash.org/utlaboriosamsint.png?size=200x200&set=set1",
    "name": "Jenkins LLC",
    "description": "Other cyst of bone, forearm",
    "monthlyPrice": 71,
    "location": "http://dummyimage.com/238x100.png/dddddd/000000"
  }, {
    "id": 8,
    "image": "https://robohash.org/estdictaexplicabo.png?size=200x200&set=set1",
    "name": "Hagenes, Kuhlman and Toy",
    "description": "Mixed hyperlipidemia",
    "monthlyPrice": 125,
    "location": "http://dummyimage.com/179x100.png/ff4444/ffffff"
  }, {
    "id": 9,
    "image": "https://robohash.org/autitaqueenim.png?size=200x200&set=set1",
    "name": "Upton, Tremblay and Keeling",
    "description": "Occupant of animal-drawn vehicle injured in collision with streetcar, initial encounter",
    "monthlyPrice": 132,
    "location": "http://dummyimage.com/190x100.png/dddddd/000000"
  }, {
    "id": 10,
    "image": "https://robohash.org/utestcommodi.png?size=200x200&set=set1",
    "name": "Stoltenberg, Wolf and Romaguera",
    "description": "Strain of unspecified muscle(s) and tendon(s) at lower leg level, right leg, initial encounter",
    "monthlyPrice": 4,
    "location": "http://dummyimage.com/150x100.png/ff4444/ffffff"
  }, {
    "id": 11,
    "image": "https://robohash.org/ullamenimexplicabo.png?size=200x200&set=set1",
    "name": "Harris, Rau and Leuschke",
    "description": "Legal intervention involving injury by rubber bullet, bystander injured, subsequent encounter",
    "monthlyPrice": 101,
    "location": "http://dummyimage.com/206x100.png/5fa2dd/ffffff"
  }, {
    "id": 12,
    "image": "https://robohash.org/officiaauttenetur.png?size=200x200&set=set1",
    "name": "Nolan, Sporer and Gottlieb",
    "description": "Other injury of left kidney",
    "monthlyPrice": 156,
    "location": "http://dummyimage.com/172x100.png/cc0000/ffffff"
  }, {
    "id": 13,
    "image": "https://robohash.org/idmolestiaecorporis.png?size=200x200&set=set1",
    "name": "Rodriguez-Welch",
    "description": "Unspecified injury of unspecified muscle, fascia and tendon at shoulder and upper arm level, unspecified arm, initial encounter",
    "monthlyPrice": 197,
    "location": "http://dummyimage.com/221x100.png/ff4444/ffffff"
  }, {
    "id": 14,
    "image": "https://robohash.org/voluptasvoluptatemquia.png?size=200x200&set=set1",
    "name": "Hane-Koch",
    "description": "Frostbite with tissue necrosis of left toe(s)",
    "monthlyPrice": 67,
    "location": "http://dummyimage.com/100x100.png/dddddd/000000"
  }, {
    "id": 15,
    "image": "https://robohash.org/explicaboaliasnobis.png?size=200x200&set=set1",
    "name": "Leffler, Bergstrom and Strosin",
    "description": "Other water transport accident, initial encounter",
    "monthlyPrice": 154,
    "location": "http://dummyimage.com/225x100.png/5fa2dd/ffffff"
  }, {
    "id": 16,
    "image": "https://robohash.org/illumrerumsit.png?size=200x200&set=set1",
    "name": "Schamberger-Fadel",
    "description": "Laceration with foreign body of unspecified front wall of thorax with penetration into thoracic cavity",
    "monthlyPrice": 175,
    "location": "http://dummyimage.com/175x100.png/dddddd/000000"
  }, {
    "id": 17,
    "image": "https://robohash.org/voluptatibusdoloret.png?size=200x200&set=set1",
    "name": "Sipes, VonRueden and Shields",
    "description": "Communicating hydrocephalus",
    "monthlyPrice": 12,
    "location": "http://dummyimage.com/152x100.png/5fa2dd/ffffff"
  }, {
    "id": 18,
    "image": "https://robohash.org/quisnobisreprehenderit.png?size=200x200&set=set1",
    "name": "Rosenbaum, Mante and Bins",
    "description": "Displaced spiral fracture of shaft of unspecified tibia, subsequent encounter for open fracture type I or II with delayed healing",
    "monthlyPrice": 166,
    "location": "http://dummyimage.com/220x100.png/ff4444/ffffff"
  }, {
    "id": 19,
    "image": "https://robohash.org/atautfuga.png?size=200x200&set=set1",
    "name": "Carroll-Goodwin",
    "description": "External constriction of right front wall of thorax, initial encounter",
    "monthlyPrice": 130,
    "location": "http://dummyimage.com/183x100.png/ff4444/ffffff"
  }, {
    "id": 20,
    "image": "https://robohash.org/etquiasuscipit.png?size=200x200&set=set1",
    "name": "Feil, Klocko and Cartwright",
    "description": "Other superficial bite of right thigh",
    "monthlyPrice": 194,
    "location": "http://dummyimage.com/173x100.png/ff4444/ffffff"
  }, {
    "id": 21,
    "image": "https://robohash.org/quasisintquaerat.png?size=200x200&set=set1",
    "name": "Ratke, Huel and Kreiger",
    "description": "Unspecified occupant of ambulance or fire engine injured in traffic accident, sequela",
    "monthlyPrice": 26,
    "location": "http://dummyimage.com/133x100.png/5fa2dd/ffffff"
  }, {
    "id": 22,
    "image": "https://robohash.org/asperioresesseincidunt.png?size=200x200&set=set1",
    "name": "Mueller, Franecki and Johns",
    "description": "Nondisplaced transverse fracture of unspecified patella, subsequent encounter for open fracture type IIIA, IIIB, or IIIC with nonunion",
    "monthlyPrice": 122,
    "location": "http://dummyimage.com/207x100.png/ff4444/ffffff"
  }, {
    "id": 23,
    "image": "https://robohash.org/accusantiumsintfacere.png?size=200x200&set=set1",
    "name": "Durgan-Hahn",
    "description": "Corrosion of third degree of multiple sites of right shoulder and upper limb, except wrist and hand, sequela",
    "monthlyPrice": 92,
    "location": "http://dummyimage.com/123x100.png/5fa2dd/ffffff"
  }, {
    "id": 24,
    "image": "https://robohash.org/quidoloremvoluptate.png?size=200x200&set=set1",
    "name": "DuBuque LLC",
    "description": "Fracture of unspecified part of unspecified clavicle",
    "monthlyPrice": 55,
    "location": "http://dummyimage.com/172x100.png/cc0000/ffffff"
  }, {
    "id": 25,
    "image": "https://robohash.org/illoenimet.png?size=200x200&set=set1",
    "name": "Fisher-Wisozk",
    "description": "Adverse effect of tetracyclic antidepressants, subsequent encounter",
    "monthlyPrice": 171,
    "location": "http://dummyimage.com/220x100.png/cc0000/ffffff"
  }] 
  
